import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
.popup-title{
    width: 100%; 
    text-align: center; 

    h2{
        font-weight: 600;
    }
}
`

export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 2rem;
  background: white;

  outline: none;

  @media (max-width: 500px) {
    width: 90%;
    padding: 1.5rem;
  }
  @media (max-width: 1200px) {
 
    margin-left: 2rem;

  }
`;